<template>
  <div class="col-md-10">
    <h4>Usuarios</h4>
    <div class="card p-3">
      <div class="card-body" v-show="mode === 'create' || mode === 'edit'">
        <div class="row">
          <div class="col-md-8">
            <div class="form-group">
              <label class="form-label">Nombre Completo<span class="text-danger"> *</span> :</label>
              <input
                v-model="form.name"
                name="name"
                id="name"
                type="text"
                class="form-control"
                placeholder="Su nombre :"
              />
            </div>
          </div>
          <div class="col-md-8">
            <div class="form-group">
              <label class="form-label">Correo electrónico<span class="text-danger"> *</span> :</label>
              <input
                v-model="form.email"
                name="email"
                id="email"
                type="email"
                class="form-control"
                placeholder="Su correo :"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-label">Permisos / Rol<span class="text-danger"> *</span> :</label>
              <select
                v-model="form.role"
                class="form-select form-control"
                aria-label="Permisos"
                placeholder="Elegir"
                :disabled="myuser.role != 'admin'"
              >
                <option value="editor">Editor</option>
                <option value="sac">SAC</option>
                <option value="legal">Legal</option>
                <option value="zona_franca">Zona Franca</option>
                <option value="admin">Administrador</option>
              </select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label"
                >Contraseña<span class="text-danger" v-show="mode === 'create'"> *</span> :</label
              >
              <input
                v-model="form.password"
                name="password"
                id="password"
                type="password"
                class="form-control"
                placeholder="Contraseña :"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label"
                >Confirmar Contraseña<span class="text-danger" v-show="mode === 'create'"> *</span> :</label
              >
              <input
                v-model="form.password_confirmation"
                name="password"
                id="password"
                type="password"
                class="form-control"
                placeholder="Contraseña :"
              />
            </div>
          </div>
          <div class="col-sm-12">
            <ul>
              <li class="text-danger" v-for="(item, index) in errors" :key="index">{{ item[0] }}</li>
            </ul>
          </div>
          <div class="col-sm-12">
            <button class="btn btn-light" @click="cancelUser()">Cancelar</button>
            <button class="btn btn-success ms-2" @click="store()" v-show="mode === 'create'">
              <i class="fal" :class="loading.store ? 'fa-circle-notch fa-spin' : 'fa-save'"></i>
              Registrar
            </button>
            <button class="btn btn-primary ms-2" @click="update()" v-show="mode === 'edit'">
              <i class="fal" :class="loading.upload ? 'fa-circle-notch fa-spin' : ''"></i>
              Actualizar
            </button>
            <div id="simple-msg"></div>
          </div>
        </div>
      </div>
      <div class="card-body" v-show="mode === 'table'">
        <button
          class="btn btn-outline-primary rounded-pill mb-2"
          :disabled="myuser.role != 'admin'"
          @click="changeMode('create')"
        >
          <i class="fal fa-plus"></i> Nuevo Usuario
        </button>
        <div class="indeterminate-progress-bar mb-2" v-show="loading.table">
          <div class="indeterminate-progress-bar__progress"></div>
        </div>
        <div class="table-responsive">
          <table class="table-dash table" v-show="Object.keys(data).length">
            <thead>
              <tr>
                <!-- <th>ID</th> -->
                <th colspan="2">Nombres / Email</th>
                <th>Permisos</th>
                <th class="text-center">Verificado</th>
                <th class="text-right">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in data.data" :key="item.id">
                <!-- <td class="text-center">{{ item.id }}</td> -->
                <td width="42"><img :src="item.PathAvatar" alt="Avatar" class="avatar" /></td>
                <td>
                  <div>{{ item.name }}</div>
                  <small class="text-muted">{{ item.email }}</small>
                </td>
                <td>
                  <span class="badge badge-primary badge-pill">{{ item.RolHuman }}</span>
                </td>
                <td class="text-center">
                  <span class="badge badge-light">{{ item.email_verified_at ? 'Si' : 'No' }}</span>
                </td>
                <td class="text-right">
                  <button
                    @click="edit(item.id)"
                    v-show="myuser.role == 'admin' || myuser.id == item.id"
                    class="btn btn-outline-light"
                  >
                    <i class="fa fa-edit"></i>
                  </button>
                  <button
                    v-show="myuser.role == 'admin'"
                    class="btn btn-outline-danger ms-1"
                    type="button"
                    @click="confirmDelete(item, index)"
                  >
                    <i class="fal fa-trash-alt"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <Pagination :data="data" @pagination-change-page="getData" />

        <vue-final-modal v-model="showModal" classes="modal-container" content-class="modal-content">
          <div class="text-center">
            <div class="mb-2"><b>Confirma que desea eliminar este usuario?</b></div>
            <span>{{ sel.name }}</span>
            <div class="d-flex justify-content-center mt-3">
              <button class="btn btn-light rounded-pill" @click="cancel()">Cancelar</button>
              <button class="btn btn-danger rounded-pill ms-2" @click="destroy()">Confirmar</button>
            </div>
          </div>
        </vue-final-modal>
      </div>
    </div>
  </div>
</template>

<script>
import LaravelVuePagination from 'laravel-vue-pagination'
export default {
  name: 'UserTable',
  components: {
    Pagination: LaravelVuePagination,
  },
  props: {
    myuser: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      mode: 'table',
      showModal: false,
      data: {},
      form: {
        id: null,
        name: null,
        email: null,
        role: null,
        password: null,
        password_confirmation: null,
      },
      sel: {},
      errors: {},
      selIndex: null,
      loading: {
        table: false,
        store: false,
        update: false,
        show: false,
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    cancelUser() {
      this.changeMode('table')
      this.clearData()
    },
    store() {
      const self = this
      self.loading.store = true
      axios
        .post('/admin/users', {
          name: self.form.name,
          email: self.form.email,
          role: self.form.role,
          password: self.form.password,
          password_confirmation: self.form.password_confirmation,
        })
        .then((res) => {
          if (res.data.success) {
            self.getData()
            self.changeMode('table')
            self.clearData()
            // self.$message({ message: res.data.message, duration: 3000, type:'success' })
          }
        })
        .catch((e) => {
          self.errors = e.response.data.errors
        })
        .finally(() => {
          self.loading.store = false
        })
    },
    update() {
      const self = this
      self.loading.update = true
      axios
        .put('/admin/users/' + self.form.id, {
          name: self.form.name,
          email: self.form.email,
          role: self.form.role,
          password: self.form.password,
          password_confirmation: self.form.password_confirmation,
        })
        .then((res) => {
          if (res.data.success) {
            self.getData()
            self.changeMode('table')
            // self.$message({ message: res.data.message, duration: 3000, type:'success' })
          }
        })
        .catch((e) => {
          self.errors = e.response.data.errors
        })
        .finally(() => {
          self.loading.update = false
        })
    },
    edit(id) {
      const self = this
      self.loading.show = true
      axios
        .get('/admin/users/' + id)
        .then((res) => {
          if (res.data.success) {
            self.form.id = res.data.data.id
            self.form.name = res.data.data.name
            self.form.role = res.data.data.role
            self.form.email = res.data.data.email
            self.changeMode('edit')
          }
        })
        .finally(() => {
          self.loading.show = false
        })
    },
    getData(page = 1) {
      const self = this
      self.loading.table = true
      axios
        .get('/admin/users', {
          params: {
            page: page,
          },
        })
        .then((res) => {
          if (res.data.success) {
            self.data = res.data.data
          }
        })
        .finally(() => {
          self.loading.table = false
        })
    },
    changeMode(mode) {
      this.mode = mode
    },
    clearData() {
      this.form = {
        id: null,
        name: null,
        email: null,
        role: null,
        password: null,
        password_confirmation: null,
      }
      this.errors = {}
    },
    confirmDelete(item, index) {
      this.sel = item
      this.selIndex = index
      this.showModal = true
    },
    cancel() {
      this.showModal = false
      this.sel = {}
      this.selIndex = null
    },
    destroy() {
      const self = this
      axios.delete('/admin/users/' + self.sel.id, {}).then((res) => {
        if (res.data.success) {
          // self.$message({ message: res.data.message, duration: 3000, type: 'success' })
          console.log(self.selIndex)
          self.data.data.splice(self.selIndex, 1)
          self.data.total--
          self.cancel()
        }
      })
    },
  },
}
</script>
